import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, renderSlot as _renderSlot, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "flex items-center"
};
const _hoisted_2 = {
  class: "font-bold w-6"
};
const _hoisted_3 = {
  class: "grow mx-2"
};
const _hoisted_4 = {
  class: "font-bold w-6 text-right"
};
const _hoisted_5 = {
  class: "flex items-center"
};
const _hoisted_6 = {
  class: "font-bold w-6"
};
const _hoisted_7 = {
  class: "grow mx-2"
};
const _hoisted_8 = {
  class: "font-bold w-6 text-right"
};
const _hoisted_9 = {
  class: "flex items-center"
};
const _hoisted_10 = {
  class: "w-6"
};
const _hoisted_11 = {
  class: "grow mx-2"
};
const _hoisted_12 = {
  class: "w-6 text-right"
};
import FormGroup from "@/modules/vue/components/FormGroup.vue";
import Talent from "@/modules/youth/components/Talent.vue";
import { PositionEnum } from "@/modules/base/enums";
import QueryPaginator from "@/modules/vue/components/QueryPaginator.vue";
import { PlayerQueryFilter } from "@/modules/global-search/services/PlayerQueryFilter";
import { PlayerQueryOrder } from "@/modules/global-search/services/PlayerQueryOrder";
import PlayerList from "@/modules/team/components/PlayerList.vue";
export default /*#__PURE__*/_defineComponent({
  __name: 'PlayerQueryPaginator',
  props: {
    query: null
  },
  setup(__props) {
    const props = __props;
    const positionOptions = ref(Object.values(PositionEnum).map(p => ({
      value: p,
      label: translator.t(p)
    })));
    const talentMapping = ref({
      1: 1,
      2: 21,
      3: 36,
      4: 51,
      5: 66,
      6: 81,
      7: 100
    });
    return (_ctx, _cache) => {
      const _component_NSelect = _resolveComponent("NSelect");
      const _component_NSlider = _resolveComponent("NSlider");
      const _component_NCheckbox = _resolveComponent("NCheckbox");
      return _openBlock(), _createBlock(QueryPaginator, {
        ref: "paginator",
        query: __props.query,
        order: _unref(PlayerQueryOrder),
        filter: _unref(PlayerQueryFilter)
      }, {
        default: _withCtx(({
          items
        }) => [_renderSlot(_ctx.$slots, "default", _normalizeProps(_guardReactiveProps({
          items
        })), () => [_createVNode(PlayerList, {
          players: items,
          "show-talent": "",
          "show-market-value": ""
        }, null, 8, ["players"])])]),
        form: _withCtx(({
          form
        }) => [_createVNode(FormGroup, {
          label: _ctx.$t('positions'),
          class: "mb-2"
        }, {
          default: _withCtx(() => [_createVNode(_component_NSelect, {
            value: form.positions,
            "onUpdate:value": $event => form.positions = $event,
            multiple: "",
            options: positionOptions.value
          }, null, 8, ["value", "onUpdate:value", "options"])]),
          _: 2
        }, 1032, ["label"]), _createVNode(FormGroup, {
          label: _ctx.$t('age'),
          class: "mb-2"
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, _toDisplayString(form.age[0]), 1), _createElementVNode("div", _hoisted_3, [_createVNode(_component_NSlider, {
            value: form.age,
            "onUpdate:value": $event => form.age = $event,
            range: "",
            step: 1,
            min: 15,
            max: 40,
            tooltip: false
          }, null, 8, ["value", "onUpdate:value"])]), _createElementVNode("div", _hoisted_4, _toDisplayString(form.age[1]), 1)])]),
          _: 2
        }, 1032, ["label"]), _createVNode(FormGroup, {
          label: _ctx.$t('skill'),
          class: "mb-2"
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, _toDisplayString(form.skill[0]), 1), _createElementVNode("div", _hoisted_7, [_createVNode(_component_NSlider, {
            value: form.skill,
            "onUpdate:value": $event => form.skill = $event,
            range: "",
            step: 1,
            min: 1,
            max: 100,
            tooltip: false
          }, null, 8, ["value", "onUpdate:value"])]), _createElementVNode("div", _hoisted_8, _toDisplayString(form.skill[1]), 1)])]),
          _: 2
        }, 1032, ["label"]), _createVNode(FormGroup, {
          label: _ctx.$t('talent'),
          class: "mb-2"
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, [_createVNode(Talent, {
            talent: talentMapping.value[form.talent[0]]
          }, null, 8, ["talent"])]), _createElementVNode("div", _hoisted_11, [_createVNode(_component_NSlider, {
            value: form.talent,
            "onUpdate:value": $event => form.talent = $event,
            range: "",
            min: 1,
            max: 7,
            tooltip: false
          }, null, 8, ["value", "onUpdate:value"])]), _createElementVNode("div", _hoisted_12, [_createVNode(Talent, {
            talent: talentMapping.value[form.talent[1]]
          }, null, 8, ["talent"])])])]),
          _: 2
        }, 1032, ["label"]), _createVNode(FormGroup, {
          class: "mb-2"
        }, {
          default: _withCtx(() => [_createVNode(_component_NCheckbox, {
            checked: form.knownTalentsOnly,
            "onUpdate:checked": $event => form.knownTalentsOnly = $event,
            label: _ctx.$t('known_talents_only')
          }, null, 8, ["checked", "onUpdate:checked", "label"])]),
          _: 2
        }, 1024), _createVNode(FormGroup, {
          class: "mb-2"
        }, {
          default: _withCtx(() => [_createVNode(_component_NCheckbox, {
            checked: form.canAffordOnly,
            "onUpdate:checked": $event => form.canAffordOnly = $event,
            label: _ctx.$t('can_afford_only')
          }, null, 8, ["checked", "onUpdate:checked", "label"])]),
          _: 2
        }, 1024)]),
        _: 3
      }, 8, ["query", "order", "filter"]);
    };
  }
});